import React from 'react';
import PropTypes from 'prop-types';

function ActionButton({
	onClick,
	text,
	isDisabled,
	containerClass,
	variant = 'default'
}) {
	let btnClass = 'btn-primary';
	switch (variant) {
		case 'primary':
			btnClass = 'btn-primary';
			break;

        case 'secondary':
            btnClass = 'btn-secondary';
            break;

		case 'outline':
			btnClass = 'btn-outline-primary';
			break;
	
		case 'default':
		default:
			break;
	}

	return (
		<div className={containerClass}>
			<button className={`btn ${btnClass}`} onClick={onClick} disabled={isDisabled}>
				{text}
			</button>
		</div>
	);
}

ActionButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	text: PropTypes.any.isRequired,
	isDisabled: PropTypes.bool,
	containerClass: PropTypes.string,
	variant: PropTypes.oneOf(['default', 'primary', 'secondary'])
};

export default ActionButton;
